import { PermissionType } from 'api/types/entity';
import { usePermissions } from 'libs/permissions';
import { useDialog } from 'libs/ui/Dialog/useDialog';

export const useAddDialogs = (onSuccessAdd: () => void) => {
  const { open: openAddHeadDialog, ...dialogAddHeadDialogProps } = useDialog();
  const { open: openAddBeneficiaryDialog, ...dialogAddBeneficiaryDialogProps } =
    useDialog();
  const { open: openAddLegalHeadDialog, ...dialogAddLegalHeadDialogProps } =
    useDialog();
  const { open: openAddBranchDialog, ...dialogAddBranchDialogProps } =
    useDialog();

  const { checkPermissions } = usePermissions();

  const canCreate = checkPermissions([
    PermissionType.LegalClientChildEntity_CreateOne,
  ]);

  const onClickAddHead = canCreate
    ? () => {
        openAddHeadDialog();
      }
    : undefined;

  const onClickAddBeneficiary = canCreate
    ? () => {
        openAddBeneficiaryDialog();
      }
    : undefined;

  const onClickAddLegalHead = canCreate
    ? () => {
        openAddLegalHeadDialog();
      }
    : undefined;

  const onClickAddBranch = canCreate
    ? () => {
        openAddBranchDialog();
      }
    : undefined;

  const closureOnSuccess = (onClose: () => void) => () => {
    onClose();
    onSuccessAdd();
  };

  const onSuccessAddHead = closureOnSuccess(dialogAddHeadDialogProps.onClose);
  const onSuccessAddBeneficiary = closureOnSuccess(
    dialogAddBeneficiaryDialogProps.onClose
  );
  const onSuccessAddLegalHead = closureOnSuccess(
    dialogAddLegalHeadDialogProps.onClose
  );
  const onSuccessAddBranch = closureOnSuccess(
    dialogAddBranchDialogProps.onClose
  );

  return {
    dialogAddHeadDialogProps,
    dialogAddBeneficiaryDialogProps,
    dialogAddLegalHeadDialogProps,
    dialogAddBranchDialogProps,
    onClickAddHead,
    onClickAddBeneficiary,
    onClickAddLegalHead,
    onClickAddBranch,
    onSuccessAddHead,
    onSuccessAddBeneficiary,
    onSuccessAddLegalHead,
    onSuccessAddBranch,
  };
};
